export default {"src":"/_next/static/media/cpadvisor.b09e67c4.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};